import { useMemo, useState } from "react";
import styled from "styled-components";
import Common from "../based/Common";
import { NOTIFY } from "../based/Constants";
import TextNumber from "../based/inputs/TextNumber";
import TFUSelect from "../based/inputs/TFUSelect";
import { Notify } from "../based/Notify";
import CommonModal from "../based/refactor/CommonModal";
import FinanceServices from "../based/services/FinanceServices";
import { WalletTypeEnum, WalletTypeOptions } from "./BalanceWithdrawal";

function WithdrawModal({ show, onClose, personalInfo, bankAccount, onSave }) {
    const [ticketModel, setTicketModel] = useState({
        walletType: WalletTypeEnum.Royalty,
        totalAmount: "",
    });

    console.log("personalInfo", personalInfo);

    const minWithdrawAmount = useMemo(() => {
        let amount = 0;
        if (!personalInfo) return amount;
        if (ticketModel.walletType === WalletTypeEnum.Royalty) {
            amount = personalInfo.royaltyWallet - personalInfo.royaltyWalletOnHold;
        } else if (ticketModel.walletType === WalletTypeEnum.Production) {
            amount = personalInfo.productionWallet;
        }
        return amount;
    }, [ticketModel]);

    const handleSave = async () => {
        console.log("personalInfo", personalInfo);
        console.log("bankAccount", bankAccount);

        if (!bankAccount) {
            Notify(NOTIFY.ERROR, NOTIFY.ERROR, "Vui lòng thêm thông tin tài khoản ngân hàng");
            return;
        }

        const [err, data] = await FinanceServices.CreateUpdateTicketPaymentHistory({
            ...ticketModel,
            paymentType: bankAccount.bankAccountType,
            bankAccountNumber: bankAccount.bankAccountNumber,
            bankCode: bankAccount.bankCode,
            bankAccountName: bankAccount.bankAccountName,
        });
        if (!err && data) {
            Notify(NOTIFY.SUCCESS, NOTIFY.SUCCESS, "Tạo thành công");
            onSave();
        } else {
            Notify(NOTIFY.ERROR, NOTIFY.ERROR, "Tạo thất bại");
        }
    };

    return (
        <CommonModal
            show={show}
            onClose={onClose}
            title="Rút tiền"
            size="md"
            customButton={
                <button
                    onClick={() => {
                        handleSave();
                    }}
                    className="btn btn-orange"
                >
                    Gửi yêu cầu
                </button>
            }
        >
            <Wrapper>
                <div className="withdraw-form">
                    <div className="withdraw-form__group">
                        <label className="withdraw-form__label" for="wallet-select">
                            Chọn ví <span className="withdraw-form__required">*</span>
                        </label>
                        <div className="withdraw-form__wallet-select">
                            <TFUSelect
                                className="withdraw-form__select"
                                options={WalletTypeOptions}
                                value={ticketModel.walletType}
                                onChanged={(val) => {
                                    setTicketModel({
                                        ...ticketModel,
                                        walletType: +val,
                                    });
                                }}
                            />
                            <div className="withdraw-form__wallet-info">
                                <div className="withdraw-form__wallet-balance">
                                    Số dư: <strong>{ticketModel.walletType == WalletTypeEnum.Royalty ? Common.formatCurrency(personalInfo.royaltyWallet) : Common.formatCurrency(personalInfo.productionWallet)}</strong>
                                </div>
                                <div className="withdraw-form__wallet-details">
                                    {ticketModel.walletType == WalletTypeEnum.Royalty ? (
                                        <>
                                            <span>Có thể rút: {Common.formatCurrency(personalInfo.royaltyWallet - personalInfo.royaltyWalletOnHold)}</span>
                                            <span>Tạm giữ: {Common.formatCurrency(personalInfo.royaltyWalletOnHold)}</span>
                                        </>
                                    ) : (
                                        <>
                                            <span>Có thể rút: {Common.formatCurrency(personalInfo.productionWallet)}</span>
                                        </>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="withdraw-form__group">
                        <label className="withdraw-form__label" for="withdraw-amount">
                            Nhập số tiền muốn rút <span className="withdraw-form__required">*</span>
                        </label>
                        <div className="withdraw-form__amount-input">
                            <TextNumber
                                className="withdraw-form__input"
                                name="withdraw-amount"
                                price
                                value={ticketModel.totalAmount}
                                onChanged={(name, value) => {
                                    setTicketModel({
                                        ...ticketModel,
                                        totalAmount: +value,
                                    });
                                }}
                            />
                        </div>
                        <div className="withdraw-form__max-note">
                            Rút tối đa <span className="withdraw-form__max-amount">{Common.formatCurrency(minWithdrawAmount)}</span>
                        </div>
                    </div>
                </div>
            </Wrapper>
        </CommonModal>
    );
}

export default WithdrawModal;

const Wrapper = styled.div`
    .withdraw-form__amount-input {
        flex-wrap: wrap;
    }

    .react-select-up > .react-select__menu {
        top: -5px !important;
        border: none !important;
    }

    .react-select__menu {
        border-radius: 0 !important;
        border: none !important;
    }

    .react-select__menu:hover {
        border-color: none !important;
        box-shadow: none !important;
        border: none !important;
    }

    .withdraw-form__amount-input .input-group {
        flex-wrap: nowrap;
    }

    label.withdraw-form__label {
        color: #303030;
        font-family: Lexend;
        font-size: 14px;
        font-style: normal;
        font-weight: 500;
        line-height: normal;
    }

    .withdraw-form__wallet-select {
        border-radius: 8px;
        border: 1px solid #e5e5e5;
        background: #fff;
        overflow: hidden;

        div {
            color: black;
            border: none;
        }
    }

    .withdraw-form__select div {
        border: none;
    }

    .withdraw-form__select div {
        border-radius: 8px 8px 0 0;
        background: #f8f8f8;
    }

    .withdraw-form__wallet-info {
        padding: 12px;
    }

    .withdraw-form__wallet-balance {
        color: #a0a0a0;
        font-family: Lexend;
        font-size: 14px;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
        display: flex;
        align-items: center;
    }

    .withdraw-form__wallet-details {
        color: #a0a0a0;
        font-family: Lexend;
        font-size: 14px;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
        display: flex;
        justify-content: space-between;
        margin-top: 12px;
    }

    .withdraw-form__wallet-balance strong {
        color: #303030;
        margin-left: 12px;
        font-weight: 600;
    }

    .withdraw-form__group {
        margin: 12px 0;
    }

    .withdraw-form__amount-input input {
        border: none;
        width: 100%;
        padding: 0 20px;
    }

    span.withdraw-form__currency {
        flex: 1;
        padding: 20px;
        background: #f3f3f3;
    }

    .withdraw-form__max-note {
        margin: 12px 0;
        color: #ff9027;
        font-family: Lexend;
        font-size: 12px;
        font-style: normal;
        font-weight: 500;
        line-height: normal;
    }

    input.withdraw-form__input {
        border-radius: 8px;
        border: 1px solid #e5e5e5;
        background: #fff;
    }

    .withdraw-form__amount-input .input-group {
        border-radius: 8px;
        border: 1px solid #e5e5e5;
        background: #fff;
        margin: 12px 0;
    }
`;
